import GeoJsonCatalogItem from "../../../../lib/Models/Catalog/CatalogItems/GeoJsonCatalogItem";
import Terria from "../../../../lib/Models/Terria";
import ViewState from "../../../../lib/ReactViewModels/ViewState";
import PointOnMap from "../../../../lib/ReactViews/Custom/Chart/PointOnMap";
import { renderWithContexts } from "../../withContext";
import { jsx as _jsx } from "react/jsx-runtime";
describe("PointOnMap", function () {
  let terria;
  let viewState;
  beforeEach(function () {
    terria = new Terria({
      baseUrl: "./"
    });
    viewState = new ViewState({
      terria,
      catalogSearchProvider: undefined
    });
  });
  it("adds the point as an overlay on mount", async function () {
    var _pointItem$geoJsonDat;
    renderWithContexts(/*#__PURE__*/_jsx(PointOnMap, {
      color: "red",
      point: {
        latitude: -37.814,
        longitude: 144.96332
      }
    }), viewState);
    const pointItem = terria.overlays.items[0];
    expect(pointItem).toBeDefined();
    expect(pointItem instanceof GeoJsonCatalogItem).toBe(true);
    await pointItem.loadMapItems();
    expect(pointItem.style["marker-color"]).toBe("red");
    const geometry = (_pointItem$geoJsonDat = pointItem.geoJsonData) === null || _pointItem$geoJsonDat === void 0 ? void 0 : _pointItem$geoJsonDat.geometry;
    expect(geometry.type).toBe("Point");
    expect(geometry.coordinates).toEqual([144.96332, -37.814]);
  });
  it("it removes the point from overlay on umount", async function () {
    const {
      unmount
    } = renderWithContexts(/*#__PURE__*/_jsx(PointOnMap, {
      color: "red",
      point: {
        latitude: -37.814,
        longitude: 144.96332
      }
    }), viewState);
    expect(terria.overlays.items.length).toBe(1);
    unmount();
    expect(terria.overlays.items.length).toBe(0);
  });
});